import { Injectable, OnInit } from '@angular/core';
import { merge } from 'lodash';
import { Location } from '@angular/common';
import { keys } from 'highcharts';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  service:any;

  // BehaviorSubject to hold the current active tab
  private currentActiveTabSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  
  // Observable to expose the current active tab
  public currentActiveTab$: Observable<string> = this.currentActiveTabSubject.asObservable();

  private subject = new Subject<any>();

  private FIVE_MN = 300 * 1000;
  private ONE_HOUR = 3600 * 1000;
  private ONE_DAY = 24 * this.ONE_HOUR;
  private ONE_WEEK = 7 * this.ONE_DAY;
  private ONE_MONTH = 30 * this.ONE_DAY;
  private ONE_QUATER = 3 * this.ONE_MONTH;
  private ONE_HALF_YEAR = 6 * this.ONE_MONTH;
  private ONE_YEAR = 365 * this.ONE_DAY;

  classOptions = [
    { name: 'Once', id: 'once', privilege: 'user', duration: Infinity },
    { name: 'Hourly', id: 'hourly', privilege: 'user', duration: this.ONE_HOUR },
    { name: 'Daily', id: 'daily', privilege: 'user', duration: this.ONE_DAY },
    { name: 'Weekly', id: 'weekly', privilege: 'user', duration: this.ONE_WEEK },
    { name: 'Monthly', id: 'monthly', privilege: 'user', duration: this.ONE_MONTH },
    { name: 'Quaterly', id: 'quaterly', privilege: 'user', duration: this.ONE_QUATER },
    { name: 'Halfyearly', id: 'halfyearly', privilege: 'user', duration: this.ONE_HALF_YEAR },
    { name: 'Yearly', id: 'yearly', privilege: 'user', duration: this.ONE_YEAR },
    { name: 'Debug', id: 'debug', privilege: 'admin', duration: this.FIVE_MN },
    { name: 'Bookable', id: 'bookable', privilege: 'admin', duration: Infinity },
    { name: 'Standard', id: 'standard', privilege: 'admin', duration: Infinity }
  ];

  constructor(private location: Location) {}

  // Method to set/update the active tab
  setActiveTab(tabRoute: string): void {
    this.currentActiveTabSubject.next(tabRoute);
  }

  // Method to get the current value without subscribing
  getCurrentActiveTab(): string {
    return this.currentActiveTabSubject.value;
  }

  // Method to clear the active tab
  clearActiveTab(): void {
    this.currentActiveTabSubject.next('');
  }

  getClassOptionsField(id: string, field: string): any {
    const classOption = this.classOptions.find(option => option.id === id);
    return classOption ? classOption[field] : '';
  }

  getClassName = (id) => {
    return this.getClassOptionsField(id, 'name')
  }

  getClassDuration = (id) => {
    return this.getClassOptionsField(id, 'duration')
  }

  getDuration = (ms) => {
    if (ms < 1000) {
      return '0s'
    }
    let s = Math.floor(ms / 1000)
    let m = Math.floor(s / 60)

    s %= 60
    let h = Math.floor(m / 60)

    m %= 60
    let d = Math.floor(h / 24)

    h %= 24
    return (d === 0 ? '' : d + 'd') +
           (h === 0 ? '' : (d === 0 ? '' : ' ') + h + 'h') +
           (m === 0 ? '' : (h === 0 ? '' : ' ') + m + 'm') +
           (s === 0 ? '' : (m === 0 ? '' : ' ') + s + 's')
  }

  // errorWrapper(fn, args) {
  //   return fn.apply(null, args).catch(function(error) {
  //     return GenericModalService.open({
  //       message: error.data ?
  //                  error.data.description :
  //                  error.status + ' ' + error.statusText
  //     , type: 'Error'
  //     , size: 'lg'
  //     , cancel: false
  //     })
  //     .then(function() {
  //       return error
  //     })
  //   })
  // }

  getIndex(array, value, property) {
    for(let i in array) {
      if (array[i][property] === value) {
        return i
      }
    }
    return -1
  }

  merge(oldObject: any, newObject: any): any {
    let undefinedValue:any;
  
    return merge(oldObject, newObject, (a: any, b: any) => {
      return Array.isArray(b) ? b : undefinedValue;
    });
  }

  isAddable(object, timeStamp) {
    return typeof object === 'undefined' ||
           timeStamp >= object.timeStamp && object.index === -1
  }

  isExisting(object) {
    return typeof object !== 'undefined' &&
           object.index !== -1
  }

  isRemovable(object, timeStamp) {
    return this.isExisting(object) &&
           timeStamp >= object.timeStamp
  }

  add(array, objects, value, property, timeStamp) {
    
    if (this.isAddable(objects[value[property]], timeStamp)) {
      objects[value[property]] = {
        index: array.push(value) - 1
      , timeStamp: timeStamp
      }
      return array[objects[value[property]].index]
    }
    return null
  }

  update(array, objects, value, property, timeStamp, noAdding?:any) {
    if (this.isExisting(objects[value[property]])) {
      this.service.merge(array[objects[value[property]].index], value)
      objects[value[property]].timeStamp = timeStamp
      return array[objects[value[property]].index]
    }
    else if (!noAdding) {
      return this.service.add(array, objects, value, property, timeStamp)
    }
    return null
  }

  delete(array, objects, key, timeStamp) {


    if (this.isRemovable(objects[key], timeStamp)) {
      const index = objects[key].index
      
      
      const value = array.splice(index, 1)[0]
      //kontya position la kiti elemnt delete karne
      objects[key].index = -1
      objects[key].timeStamp = timeStamp
      for (let k in objects) {
        if (objects[k].index > index) {
          objects[k].index--
        }
      }

      

      return value
      
    }
    else if (typeof objects[key] === 'undefined') {
      objects[key] = {
        index: -1
      , timeStamp: timeStamp
      }
    }
    return null
  }

  sortBy(data, column) {
    const index = this.getIndex(data.columns, column.name, 'name')

    if (index !== data.sort.index) {
      data.sort.reverse = false
      column.sort = 'sort-asc'
      data.columns[data.sort.index].sort = 'none'
      data.sort.index = index
    }
    else {
      data.sort.reverse = !data.sort.reverse
      column.sort = column.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc'
    }
    return this.service
  }

  isOriginGroup(_class) {
    return _class === 'bookable' || _class === 'standard'
  }

  isNoRepetitionsGroup(_class) {
    return this.isOriginGroup(_class) || _class === 'once'
  }

  url(url: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.click();
    document.body.removeChild(a);
    return this.service;
  }

  copyToClipboard(data: string) {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.value = data;
    input.select();
    navigator.clipboard.writeText('copy');
    document.body.removeChild(input);
    return this.service;
  }

  getBaseUrl(): string {
    const protocol = document.location.protocol;
    const host = document.location.hostname;
    const port = document.location.port;
    return `${protocol}//${host}:${port}`;
  }


  setDataObject(obj) { 
    this.subject.next(obj) 
   }
  
   getDataObject(): Observable <any> {
    return this.subject;
   }
}
